<template>
    <div class="note">
        <div
            class="pb-2"
            :key="note.id"
            v-for="note in displayedNotes">
            <div class="d-flex align-items-end justify-content-start">
                <h5 class="h5 mb-0">Note by {{ note.admin.first_name }}</h5>
                <p class="note__time">
                    in {{ note.created_at | fixDateTime }}
                </p>
            </div>

            <div class="note__item">
                <p class="mb-0">{{ note.notes }}</p>
            </div>
        </div>
        <div class="action"
             v-if="notes?.length > 2">
            <button @click="toggleNotes">
                {{ showAll ? 'See Less' : 'See All' }}
            </button>
        </div>
        
    </div>
</template>

<script>
export default {
    name: 'kycAccountNotes',

    props: {
        notes: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            showAll: false
        }
    },

    computed: {
        displayedNotes() {
            if (this.showAll) {
                return this.notes
            }
            return this.notes.slice(0, 2)
        }
    },

    methods: {
        toggleNotes() {
            this.showAll = !this.showAll
        }
    }
}
</script>
